import api, { normalizeList } from './api';

export const notificationService = {
    // Get all notifications for the current user
    getNotifications: async (params = {}) => {
        const response = await api.get('/api/notifications/', { params });
        return response.data; // This returns the full paginated object for usePagination
    },

    // Get recent notifications (last 7 days)
    getRecentNotifications: async () => {
        const response = await api.get('/api/notifications/recent/');
        return normalizeList(response.data);
    },

    // Get unread count
    getUnreadCount: async () => {
        const response = await api.get('/api/notifications/unread_count/');
        return response.data;
    },

    // Mark a specific notification as read
    markAsRead: async (notificationId) => {
        const response = await api.post(`/api/notifications/${notificationId}/mark_as_read/`);
        return response.data;
    },

    // Mark all notifications as read
    markAllAsRead: async () => {
        const response = await api.post('/api/notifications/mark_all_as_read/');
        return response.data;
    },

    // Get a specific notification
    getNotification: async (notificationId) => {
        const response = await api.get(`/api/notifications/${notificationId}/`);
        return response.data;
    }
}; 